import { BaseViewModel } from "./base.viewmodel";

export class ProjectsViewmodel extends BaseViewModel {
    override PageTitle: string = "Projects";
    currentSubProject: number = 0;
}
